<template>
  <div>
    <div class="d-flex justify-space-between align-center pa-4 pa-md-2">
      <Breadcrumbs
        headline="Đơn hàng"
        :link="[{ text: 'Đơn hàng', href: '../leads' }]"
      />
    </div>
    <v-card class="pa-2 mx-md-2">
      <div class="py-1 text-right">
        <lead-filter-dialog @onFilter="refresh" v-if="$vuetify.breakpoint.xs" />
        <setting-table-header
          :default-headers="originHeaders"
          @change="headers = $event"
        />
        <KebapMenu v-if="!$vuetify.breakpoint.xs">
          <v-list>
            <v-list-item>
              <export-excel :custom-header="headers" api="/leads/" />
            </v-list-item>
          </v-list>
        </KebapMenu>
      </div>
      <v-data-table
        class="nowrap px-1"
        :headers="headers"
        :items="leads"
        :search="search"
        :items-per-page="5"
        :loading="loading"
        select
        dense
        disable-sort
      >
        <template v-slot:top>
          <lead-filter
            @onFilterChanged="refresh"
            v-if="!$vuetify.breakpoint.xs"
          ></lead-filter>
          <report v-if="false" :leads="leads" />
        </template>
        <template v-slot:[`item.code`]="{ item }">
          <router-link to @click.native.stop="onEdit(item)">{{
            item.code
          }}</router-link>
        </template>
        <template v-slot:[`item.total`]="{ item }">
          <div>{{ item.total | formatMoney }}</div>
        </template>
        <template v-slot:[`item.paymentType`]="{ item }">
          <div>{{ allPaymentTypes[item.paymentType] }}</div>
        </template>
        <template v-slot:[`item.customerName`]="{ item }">
          <div>{{ item.customerName }}</div>
        </template>
        <template v-slot:[`item.tags`]="{ item }">
          <div>{{ item.tags }}</div>
        </template>
        <template v-slot:[`item.liabilities`]="{ item }">
          <div>{{ item.liabilities | formatMoney }}</div>
        </template>
        <template v-slot:[`item.customerPaid`]="{ item }">
          <div>{{ item.customerPaid | formatMoney }}</div>
        </template>
        <template v-slot:[`item.staff`]="{ item }">
          <div>{{ item.staff.name }}</div>
        </template>
        <template v-slot:[`item.date`]="{ item }">
          <div>{{ item.date | familiarizeDate }}</div>
        </template>
        <template v-slot:[`item.provider`]="{ item }">
          <div>{{ item.provider }}</div>
        </template>
        <template v-slot:[`item.items`]="{ item }">
          <router-link
            v-for="data in item.items"
            :key="data.id"
            :to="'/lead/' + data.id"
            >{{ data.title }},</router-link
          >
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip :color="getColor(item.status)" small dark>{{
            allLeadStatus[item.status]
          }}</v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon>
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click.stop="onApprove(item)">
                  <v-list-item-title
                    ><v-icon>receipt</v-icon> Duyệt Đơn</v-list-item-title
                  >
                </v-list-item>
                <v-list-item @click.stop="onRemove(item)">
                  <v-list-item-title>
                    <v-icon>delete</v-icon> Xóa</v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <template v-slot:[`item.type`]="{ item }">
          <span>{{ allLeadTypes[item.type] }}</span>
        </template>
        <template v-slot:[`item.state`]="{ item }">
          <span>{{ item.state | getState }}</span>
        </template>
      </v-data-table>
    </v-card>

    <lead-edit :lead="selected" :state="dialog" @updateLead="updateLead" />
    <lead-approval :lead="selected" :state="appDialog" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
import LeadFilter from '@/modules/lead/LeadFilter'
import LeadFilterDialog from '@/modules/lead/LeadFilterDialog.vue'
import Report from '@/modules/lead/LeadReport'
import LeadEdit from '@/modules/lead/LeadEditDialog.vue'
import LeadApproval from '@/modules/lead/LeadApprovalDialog.vue'
import utils from '@/plugins/utils.js'
import SettingTableHeader from '@/components/basic/table/SettingHeaders'
import ExportExcel from '@/components/basic/ExportExcel'
import KebapMenu from '@/components/basic/menu/KebapMenu.vue'
import Breadcrumbs from '@/components/layout/Breadcrumbs'

const originHeaders = [
  {
    text: 'Mã hóa đơn',
    align: 'left',
    sortable: false,
    value: 'code',
    show: true
  },
  { text: 'Trạng thái', value: 'status', show: true },
  { text: 'Tên người nộp tiền', value: 'customerName', show: true },
  { text: 'Đã Nộp', value: 'customerPaid', show: true },
  { text: 'Ngày lập hóa đơn', value: 'date', show: true },
  { text: 'Thanh Toán', value: 'paymentType', show: true },
  { text: 'Duyệt', value: 'state', show: true },
  { text: 'Nguời lập hóa đơn', value: 'staff', show: true },
  { text: 'Hành động', value: 'actions', show: true }
]

export default {
  components: {
    LeadFilter,
    LeadEdit,
    LeadApproval,
    Report,
    SettingTableHeader,
    ExportExcel,
    KebapMenu,
    Breadcrumbs,
    LeadFilterDialog
  },
  data() {
    return {
      search: '',
      expanded: [],
      loading: false,
      dialog: false,
      originHeaders: originHeaders,
      headers: [],
      appDialog: false,
      leadId: '',
      selected: {}
    }
  },
  computed: {
    ...mapGetters('leads', ['leads', 'lead']),
    ...mapState('constant', [
      'leadStatus',
      'leadTypes',
      'paymentTypes',
      'leadTypes'
    ]),
    ...mapGetters('app', ['department']),
    allLeadStatus() {
      return this.leadStatus.reduce(
        (data, curent) => ({
          ...data,
          [curent.status]: curent['title']
        }),
        {}
      )
    },
    allLeadTypes() {
      return this.leadTypes.reduce(
        (data, curent) => ({
          ...data,
          [curent.status]: curent['title']
        }),
        {}
      )
    },
    allPaymentTypes() {
      return this.paymentTypes.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.status]: cur.title
        }),
        {}
      )
    },
    leadData() {
      return this.lead(this.leadId)
    }
  },
  async mounted() {
    if (this.leads.length === 0) {
      await this.refresh('')
    }
  },
  methods: {
    ...mapActions('leads', [
      'fetchLeads',
      'setLead',
      'updateLead',
      'removeLead'
    ]),
    updateDraw(state) {
      this.draw = state
    },
    onRemove(lead) {
      if (lead.bills && lead.bills.length) {
        this.$dialog.confirm({
          title: 'Không thể xóa?',
          text:
            'Không thể xóa vì Đơn Hàng này có liên kết với một hoặc nhiều hóa đơn. Xem thêm ở mục lịch sử giao dịch',
          okText: 'Đã hiểu'
        })
        return
      } else {
        this.$dialog.confirm({
          title: 'Xóa Hóa đơn này?',
          text:
            'Bạn có chắc chắn muốn xóa hóa đơn này. Dữ liệu này sau khi xóa sẽ không thể phục hồi. Bạn có chắn chắn?',
          okText: 'Có',
          cancelText: 'Không',
          done: async () => {
            await this.removeLead(lead.id)
          }
        })
      }
      this.$dialog.confirm({
        title: 'Xóa Hóa đơn này?',
        text:
          'Bạn có chắc chắn muốn xóa hóa đơn này. Dữ liệu này sau khi xóa sẽ không thể phục hồi. Bạn có chắn chắn?',
        okText: 'Có',
        cancelText: 'Không',
        done: async () => {
          await this.removeLead(lead.id)
        }
      })
    },
    onEdit(lead) {
      this.selected = lead
      this.dialog = !this.dialog
    },
    onApprove(lead) {
      this.selected = lead
      this.appDialog = !this.appDialog
    },
    async refresh(query) {
      this.loading = true
      await this.fetchLeads({ ...query, _sort: 'createdAt:DESC' })
      this.loading = false
    },
    getColor(status) {
      if (status === 'paid') return 'green'
      else if (status === 'rejected') return 'red'
      else if (status === 'opened') return 'blue'
      else if (status === 'canceled') return 'orange'
      else return 'gray'
    }
  },
  filters: {
    familiarizeDate: time => {
      if (!time) {
        return 'None'
      }
      return moment(time).format('DD/MM/YYYY')
    },
    SimplizedDate: time => {
      if (!time) {
        return 'None'
      }
      return moment(time).format('DD/MM')
    },
    formatMoney(data) {
      return utils.formatMoney(data)
    },
    getState(state) {
      if (state === 'approved') return 'Đã Duyệt'
      else if (state === 'under-approval') return 'Chưa Duyệt'
    }
  }
}
</script>
<style></style>
